import styled from 'styled-components'

import { Select } from '@/components/shared-components/BUI/Select'
import { Text } from '@/components/shared-components/BUI/Text'
import config from '@/config/index'

const REGIONS = {
  au: {
    url: 'https://app.buildpass.com.au',
    name: 'Oceania',
    flag: '🇦🇺',
  },
  us: {
    url: 'https://app.buildpass.ai',
    name: 'North America',
    flag: '🇺🇸 🇨🇦',
  },
}

const RegionSelectorContainer = styled.div``

const getCurrentRegion = () => {
  const regionEntries = Object.entries(REGIONS)
  const currentRegion = regionEntries.find(
    ([_, region]) => config.appHost === region.url
  )
  return currentRegion ? currentRegion[0] : 'au' // Default to Australia if not found
}

const REGION_OPTIONS = Object.entries(REGIONS).map(([code, region]) => {
  return {
    label: (
      <Text>
        {region.flag} {region.name}
      </Text>
    ),
    value: code,
  }
})

export const RegionSelector = () => {
  const currentRegion = getCurrentRegion()

  const handleRegionChange = (value: string) => {
    const selectedRegion = REGIONS[value as keyof typeof REGIONS]
    if (selectedRegion) {
      window.location.href = selectedRegion.url
    }
  }

  return (
    <RegionSelectorContainer>
      <Select
        $fullWidth={true}
        options={REGION_OPTIONS}
        defaultValue={currentRegion}
        onChange={handleRegionChange}
        dropdownMatchSelectWidth={false}
      />
    </RegionSelectorContainer>
  )
}
